module.exports = __webpack_public_path__ + "static/img/service-agent.d090c75f.svg";